import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {ICashboxTypeRepository} from "@/repository/finance/cashbox/CashboxTypeRepository.types";
import {ICashboxType, CashboxTypeResponseType} from "@/entity/finance/cashbox/cashboxType.types";
import CashboxType from "@/entity/finance/cashbox/cashboxType";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import {CashboxAddFormRequestType} from "@/form/finance/cashbox/CashboxAddForm.types";


export class CashboxTypeRepository implements ICashboxTypeRepository {
    async fetchAll(data?: PaginationRequestType): Promise<ICashboxType[]> {
        const resp = await Api.get('/finance/cashbox/types/get', { params: data, paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const respData = resp.data as CashboxTypeResponseType[];
        return respData.map((items: CashboxTypeResponseType) => new CashboxType(items));
    }
    async create(data: CashboxAddFormRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/finance/cashbox/create', data);
        return response.data;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/finance/cashbox/types/delete', data);
        return resp.data;
    }
}